import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import {
  LayoutDashboard, ClipboardList, Wrench, Calendar, Receipt,
  Users, Package, MessageCircle, Settings, ChevronLeft, ChevronRight, LogOut,
  Image as ImgIcon, BookOpen, Calculator
} from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/quotes", label: "Quotes", icon: ClipboardList },
  { to: "/admin/jobs", label: "Jobs", icon: Wrench },
  { to: "/admin/bookings", label: "Bookings", icon: Calendar },
  { to: "/admin/invoices", label: "Invoices", icon: Receipt },
  { to: "/admin/accounting", label: "Accounting", icon: Calculator },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/gallery", label: "Gallery", icon: ImgIcon },
  { to: "/admin/blogs", label: "Blog", icon: BookOpen },
  { to: "/admin/chat", label: "Chat", icon: MessageCircle },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminSidebar({ collapsed, setCollapsed }) {
  const loc = useLocation();
  const nav = useNavigate();
  const { logout } = useAuth();
  const isActive = (n) => n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);

  return (
    <aside className={`sticky top-0 h-screen shrink-0 bg-card border-r border-border transition-all duration-300 flex flex-col ${collapsed ? "w-[72px]" : "w-64"}`}>
      <div className={`h-16 flex items-center border-b border-border ${collapsed ? "justify-center" : "px-5"}`}>
        {collapsed ? <Logo size={26} showText={false} /> : <Logo size={26} />}
      </div>
      <nav className="flex-1 py-4 px-2 space-y-1 overflow-y-auto">
        {NAV.map(n => {
          const active = isActive(n);
          return (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`sidebar-${n.label.toLowerCase()}`}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                active ? "bg-eagle-gold text-eagle-ink" : "text-muted-foreground hover:bg-secondary hover:text-foreground"
              } ${collapsed ? "justify-center" : ""}`}
              title={collapsed ? n.label : ""}
            >
              <n.icon className="h-4 w-4 shrink-0" />
              {!collapsed && <span>{n.label}</span>}
            </Link>
          );
        })}
      </nav>
      <div className="p-2 border-t border-border space-y-1">
        <button
          onClick={async () => { await logout(); nav("/"); }}
          data-testid="sidebar-logout"
          className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors ${collapsed ? "justify-center" : ""}`}
          title={collapsed ? "Sign out" : ""}
        >
          <LogOut className="h-4 w-4 shrink-0" />
          {!collapsed && <span>Sign out</span>}
        </button>
        <button
          onClick={() => setCollapsed(!collapsed)}
          data-testid="sidebar-collapse-toggle"
          className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:bg-secondary transition-colors ${collapsed ? "justify-center" : ""}`}
          title={collapsed ? "Expand" : "Collapse"}
        >
          {collapsed ? <ChevronRight className="h-4 w-4" /> : <><ChevronLeft className="h-4 w-4" /><span>Collapse</span></>}
        </button>
      </div>
    </aside>
  );
}
